// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"638035a9","453":"09e7e302","555":"d00813a9","683":"273e6a06","728":"136d6ec0"}[chunkId] + ".chunk.js";
};